export const pillars = [
  'Medizinische Beurteilung',
  'Progressive Protokolle',
  'Return-to-Sport',
  'Langfristige Prävention',
];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'Die Biomechanik der Heilung',
  desc: 'Verstehen Sie die biologischen Gesetze der Gewebereparatur. Wir dechiffrieren, wie Sehnen, Muskeln und Bänder wirklich heilen, damit Sie nie wieder gegen Ihren eigenen Körper arbeiten, sondern den Heilungsprozess physikalisch beschleunigen.'
}, {
  n: 2,
  emoji: '📗',
  title: 'Das Ampel-System (Die Reha-Matrix)',
  desc: 'Unser Herzstück. Das visuelle Navigationssystem, das Ihnen genau sagt: Grün (Belastung steigern), Gelb (Vorsicht/Stagnation) oder Rot (Stopp). Eliminieren Sie das gefährliche Rätselraten und wissen Sie jede Sekunde, ob Sie auf dem richtigen Weg sind.'
}, {
  n: 3,
  emoji: '📙',
  title: 'Phasen-Strategie: Von Null auf Hundert',
  desc: 'Der präzise Fahrplan der Genesung. Wir teilen den Weg in klare, messbare Phasen ein – von der initialen Entzündungskontrolle bis zur Rückkehr zur maximalen sportlichen Belastung. Jede Phase hat klare Kriterien, die Sie erfüllen müssen, bevor Sie weitergehen.'
}, {
  n: 4,
  emoji: '📕',
  title: 'Neuromuskuläre Reset-Protokolle',
  desc: 'Schmerz findet im Gehirn statt. Dieser Band lehrt Sie, wie Sie das „Schmerzgedächtnis" löschen und Ihre Muskeln wieder korrekt ansteuern. Das neuronale Update, um Kraft und Beweglichkeit zurückzuholen, die Ihr Gehirn aus Schutz blockiert hat.'
}, {
  n: 5,
  emoji: '📓',
  title: 'Der Belastbarkeits-Faktor',
  desc: 'Hier bauen wir die „Rüstung" auf. Lernen Sie, wie Sie Ihr Gewebe so konditionieren, dass es mehr Last aushält als vor der Verletzung. Fokus auf strukturelle Integrität, damit Ihr Körper unter Druck nicht mehr einknickt.'
}, {
  n: 6,
  emoji: '📔',
  title: 'Psychologie der Verletzung & Prävention',
  desc: 'Der mentale Schutzschild. Überwinden Sie die Angst vor der erneuten Verletzung und installieren Sie ein dauerhaftes Wartungssystem (A.R.M.A.), das sicherstellt, dass Sie nie wieder an den Punkt Null zurückkehren müssen.'
}];
export const volumeIncludes = ['Visuelle Schritt-für-Schritt-Protokolle mit Bildern', 'Medizinische Beurteilungskriterien', 'Traffic Light System für Progression', 'Return-to-Sport Checkpoints', 'Tägliche Trainings-Checklisten', 'Druckbare Tracking-Sheets', 'Designed für Anfänger und Profis', 'Sofort einsatzbereit vom ersten Tag'];
export const bonuses = [{
  n: '01',
  title: 'Das Load-Master Protokoll — Maximale Kraft ohne Rückfall 🏋️‍♂️',
  desc: 'Das ultimative System zur Laststeuerung. Erfahren Sie exakt, mit wie viel Gewicht, Sätzen und Wiederholungen Sie trainieren müssen, um Fortschritte zu erzwingen, ohne das Gewebe zu überlasten. Die mathematische Sicherheit für Ihren Kraftaufbau.',
  price: '$67',
  cover: 'https://cdn.magicpatterns.com/uploads/2UJe3vXGYe8jkiB1kyEeL8/ChatGPT_Image_14_sept_2026,_16_36_09.png'
}, {
  n: '02',
  title: 'Das A.R.M.A. Präventions-Schild 🛡️',
  desc: 'Ihr lebenslanger Wartungsplan. A.R.M.A. (Assessment, Resilience, Maintenance, Action) erkennt Schwachstellen, bevor sie zu Verletzungen werden. Verwandeln Sie Ihren Körper in eine uneinnehmbare Festung gegen zukünftige Schmerzen.',
  price: '$47',
  cover: 'https://cdn.magicpatterns.com/uploads/9MPzH4g7rfuEbPLWaAMRNF/ChatGPT_Image_14_sept_2026,_16_36_10.png'
}, {
  n: '03',
  title: 'Dynamische Aktivierungs-Matrix ⚡',
  desc: 'Vergessen Sie statisches Dehnen. Diese Matrix bietet sport-spezifische Warm-up-Protokolle, die Ihr Nervensystem „aufwecken" und Ihre Gelenke auf maximale Leistung vorbereiten. Ideal für Läufer, CrossFitter und Athleten, die sofortige Einsatzbereitschaft brauchen.',
  price: '$37',
  cover: 'https://cdn.magicpatterns.com/uploads/rypqohVDyMAqEvUcqCeoUG/ChatGPT_Image_14_sept_2026,_16_36_14.png'
}, {
  n: '04',
  title: 'Anti-Entzündungs-Guide 🍎',
  desc: 'Die biochemische Unterstützung Ihrer Heilung. Erfahren Sie, welche Mikronährstoffe und Lebensmittel die Entzündungswerte senken und die Gewebereparatur auf zellulärer Ebene beschleunigen. Heilen Sie von innen heraus.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/25HvLfk7tKfVmGgUJiRGvM/ChatGPT_Image_14_sept_2026,_16_36_16.png'
}, {
  n: '05',
  title: 'Der 360° Fortschritts-Planer 📅',
  desc: 'Was man nicht misst, kann man nicht verbessern. Dieser visuelle Kalender und Tracker hilft Ihnen, jede Phase Ihrer Rehabilitation zu dokumentieren. Behalten Sie die volle Kontrolle über Ihre Meilensteine und feiern Sie jeden Fortschritt schwarz auf weiß.',
  price: '$17',
  cover: 'https://cdn.magicpatterns.com/uploads/tyPUZA6kbm7zRbRrV2oyCu/ChatGPT_Image_14_sept_2026,_16_36_18.png'
}];
